// extracted by mini-css-extract-plugin
module.exports = {"showLess":"showLess_showLess__1a-8h","more":"showLess_more__1tA7y","toggle":"showLess_toggle__1QG5b"};